window.addEventListener("load", () => {
	const flickityDots = document.querySelectorAll(".flickity-page-dots .dot");
	if (flickityDots) {
		flickityDots.forEach((dot, index) => {
			dot.setAttribute("tabIndex", "0");
			dot.addEventListener("keydown", (event: KeyboardEvent) => {
				if (event.key === "Enter") {
					(dot as HTMLElement).click();
					(dot as HTMLElement).focus();
				}
			});
		});
	}
});
